type LogLevel = 'info' | 'warn' | 'error' | 'debug'

export class Logger {
  private context: string

  constructor(context: string) {
    this.context = context
  }

  private log(level: LogLevel, message: string, data?: any) {
    const timestamp = new Date().toISOString()
    const logData = {
      timestamp,
      level,
      context: this.context,
      message,
      ...(data && { data })
    }

    switch (level) {
      case 'error':
        console.error(`[${this.context}]`, message, data || '')
        break
      case 'warn':
        console.warn(`[${this.context}]`, message, data || '')
        break
      case 'debug':
        console.debug(`[${this.context}]`, message, data || '')
        break
      default:
        console.log(`[${this.context}]`, message, data || '')
    }

    // You could also send logs to a monitoring service here
  }

  info(message: string, data?: any) {
    this.log('info', message, data)
  }

  warn(message: string, data?: any) {
    this.log('warn', message, data)
  }

  error(message: string, data?: any) {
    this.log('error', message, data)
  }

  debug(message: string, data?: any) {
    this.log('debug', message, data)
  }
}
